// extracted by mini-css-extract-plugin
export default {"social-links":"Links-module__social-links--xmUXN","front-links":"Links-module__front-links--Qa9-l"};